// Module
var code = "<div class=\"recipe-list-container\"> <div layout=\"row\" layout-align=\"space-between center\"> <h2 class=\"title-page\">My Recipes</h2> <button id=\"add-new-recipe-btn\" class=\"outline\" ng-click=\"vm.goTo('/add-recipe')\">+ Add new recipe</button> </div> <recipe-list></recipe-list> </div>";
// Exports
var _module_exports = code;;
var path = 'app/components/recipes/recipes.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;